import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconReplayStyle0 = cosmosIconCss;

const CosmosIconReplay$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconReplay extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'be89cd8dbd45617d5203672a6c7a5ee2773514d1', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '95b05a50374b2c5dbfd4a55e357e1815ccd0bcfc', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '61d50b712f46fc166ba1d93701c1d1eec1408dbb', d: "M10.993 18.6a6.504 6.504 0 0 1-6.487-6 .532.532 0 0 0-.52-.5h-.5a.477.477 0 0 0-.485.5 8.005 8.005 0 0 0 7.992 7.5c4.422 0 8.007-3.582 8.007-8s-3.585-8-8.007-8H8.674l-.003-2.196a.4.4 0 0 0-.68-.29l-3.004 3a.4.4 0 0 0 0 .56l3.003 3a.4.4 0 0 0 .69-.29L8.678 5.6h2.316a6.503 6.503 0 0 1 6.506 6.5c0 3.59-2.913 6.5-6.506 6.5Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconReplayStyle0; }
}, [1, "cosmos-icon-replay", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-replay"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-replay":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconReplay$1);
            }
            break;
    } });
}

const CosmosIconReplay = CosmosIconReplay$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconReplay, defineCustomElement };
